module.exports = __webpack_public_path__ + "static/img/lost2.b20b4307.png";